export default __webpack_public_path__ + "static/media/i049vp.565663d1.webp";